import {
  Home,
  Clock,
  Users,
  FolderKanban,
  BarChart3,
  TrendingUp,
  CheckCircle2,
  GitBranch,
  Settings,
  CreditCard,
  Plug,
  Bell,
  Shield,
  UserCog,
  Monitor,
  FileText,
  Database,
  Sliders,
  Briefcase,
  PoundSterling,
  Archive,
  Download,
  Upload,
  ClipboardCheck,
  AlertTriangle,
  UserCheck,
} from "lucide-react";
import type { MenuItem } from "../types";

/**
 * Menu Items Configuration
 * Define your menu structure here
 */
export const menuItems: MenuItem[] = [
  { id: "homepage", label: "Homepage", icon: Home, page: "/" },
  { id: "timesheet", label: "Timesheet", icon: Clock, page: "/timesheet" },
  {
    id: "approvals",
    label: "Approvals",
    icon: CheckCircle2,
    page: "/approvals",
    children: [
      { id: "approvals-dashboard", label: "Approvals Queue", icon: CheckCircle2, page: "/approvals" },
      { id: "approvals-my-delegations", label: "My Delegations", icon: UserCheck, page: "/approvals/delegations" },
    ],
  },
  { 
    id: "reports", 
    label: "Reports", 
    icon: BarChart3, 
    page: "/reports/timesheet",
    children: [
      { id: "reports-timesheet", label: "Timesheet Reports", icon: FileText, page: "/reports/timesheet" },
      { id: "reports-missing-timesheets", label: "Missing Timesheets", icon: AlertTriangle, page: "/reports/missing-timesheets" },
      { id: "reports-utilisation", label: "Utilisation", icon: TrendingUp, page: "/reports/utilisation" },
    ]
  },
  { 
    id: "team", 
    label: "Team", 
    icon: Users, 
    page: "/team/members",
    children: [
      { id: "team-members", label: "Members", icon: Users, page: "/team/members" },
    ]
  },
  { 
    id: "projects", 
    label: "Projects", 
    icon: FolderKanban, 
    page: "/projects/active",
    children: [
      { id: "projects-active", label: "Active", icon: FolderKanban, page: "/projects/active" },
      // Hidden: Archive and Budget menu items temporarily hidden per request
      // { id: "projects-archive", label: "Archive", icon: Archive, page: "/projects/archive" },
      // { id: "projects-budget", label: "Budget", icon: PoundSterling, page: "/projects/budget" },
    ]
  },
  // Hidden: Import/Export menu item temporarily hidden per request
  // {
  //   id: "data",
  //   label: "Import/Export",
  //   icon: Database,
  //   page: "/data/import",
  //   children: [
  //     { id: "data-import", label: "Import", icon: Upload, page: "/data/import" },
  //     { id: "data-export", label: "Export", icon: Download, page: "/data/export" },
  //   ]
  // },
];

/**
 * Settings Menu Items Configuration
 * Nested settings pages
 */
export const settingsMenuItems: MenuItem[] = [
  { id: "settings-general", label: "General", icon: Settings, page: "/settings/general" },
  { id: "settings-roles-permissions", label: "Roles & Permissions", icon: UserCog, page: "/settings/roles-permissions" },
  { id: "settings-approvals", label: "Approvals", icon: ClipboardCheck, page: "/settings/approvals" },
  { id: "settings-approvals-delegation", label: "Approval Delegation", icon: UserCheck, page: "/settings/approvals/delegation" },
  { id: "settings-approvals-delegation-audit", label: "Delegation Audit", icon: ClipboardCheck, page: "/settings/approvals/delegation/audit" },
  // Hidden: Screen Data Modes menu item temporarily hidden per request
  // { id: "settings-screens", label: "Screen Data Modes", icon: Monitor, page: "/settings/screens" },
  { id: "settings-roles", label: "Roles & Rates", icon: CreditCard, page: "/settings/roles" },
  { id: "settings-notifications", label: "Notifications", icon: Bell, page: "/settings/notifications" },
  { id: "integrations", label: "Integrations", icon: Plug, page: "/integrations" },
];

/**
 * Database Options Configuration
 * Not used in this application
 */
export const databases = [];

/**
 * Menu Configuration
 */
export const menuConfig = {
  /** Total number of pages (7 main + 11 children + 10 settings = 28) */
  totalPages: 28,
  /** Minimum pages required to enable favorites feature */
  favoritesThreshold: 10,
  /** Show database switcher in footer */
  showDatabaseSwitcher: false,
  /** Show settings button in footer */
  showSettings: true,
};
